module.exports = __webpack_public_path__ + "static/media/news-poststar.c73fff5f.jpg";